var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#4B1598"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5827 21.5417H15.0827C14.5074 21.5417 14.041 22.0081 14.041 22.5834V30.0834C14.041 30.6587 14.5074 31.125 15.0827 31.125H17.5827C18.158 31.125 18.6243 30.6587 18.6243 30.0834V22.5834C18.6243 22.0081 18.158 21.5417 17.5827 21.5417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2487 18.2083H21.7487C21.1734 18.2083 20.707 18.6747 20.707 19.25V30.0833C20.707 30.6586 21.1734 31.125 21.7487 31.125H24.2487C24.824 31.125 25.2904 30.6586 25.2904 30.0833V19.25C25.2904 18.6747 24.824 18.2083 24.2487 18.2083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9167 14.875H28.4167C27.8414 14.875 27.375 15.3414 27.375 15.9167V30.0833C27.375 30.6586 27.8414 31.125 28.4167 31.125H30.9167C31.492 31.125 31.9583 30.6586 31.9583 30.0833V15.9167C31.9583 15.3414 31.492 14.875 30.9167 14.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestTrends);
export default __webpack_public_path__ + "static/media/latest-trends.747b949e83fa6692dcee1058223618c9.svg";
export { ForwardRef as ReactComponent };